/** Тексты окна: Окно VIP. */
import type { MessageBundle } from "../../../i18n";

const en = {
  "win.vip.title": "VIP",
  "win.vip.noWait": "No wait after the base falls",
  "win.vip.speed": "x2 battle speed",
  "win.vip.auto": "Auto skills",
  "win.vip.revive": "One free rematch per wave",
  "win.vip.buy": "Get VIP",
  "win.vip.terms": "30 days, renews automatically. Cancel any time in Telegram.",
  "win.vip.later": "Not now",
} as const;

type Key = keyof typeof en;

const ru: Record<Key, string> = {
  "win.vip.title": "VIP",
  "win.vip.noWait": "Без ожидания после падения штаба",
  "win.vip.speed": "Скорость боя x2",
  "win.vip.auto": "Автонавыки",
  "win.vip.revive": "Бесплатный реванш на каждую волну",
  "win.vip.buy": "Взять VIP",
  "win.vip.terms": "30 дней, продлевается автоматически. Отменить можно в любой момент в Telegram.",
  "win.vip.later": "Не сейчас",
};

const uk: Record<Key, string> = {
  "win.vip.title": "VIP",
  "win.vip.noWait": "Без очікування після падіння штабу",
  "win.vip.speed": "Швидкість бою x2",
  "win.vip.auto": "Автонавички",
  "win.vip.revive": "Безкоштовний реванш на кожну хвилю",
  "win.vip.buy": "Узяти VIP",
  "win.vip.terms": "30 днів, продовжується автоматично. Скасувати можна будь-коли в Telegram.",
  "win.vip.later": "Не зараз",
};

export const messages: MessageBundle<Key> = { en, ru, uk };
